import React , {memo , useState} from 'react';
import { useDispatch } from 'react-redux';

import classes from './Hamburger.module.scss';
import DrawerMenu from './components/DrawerMenu';
import HamburgerIcon from './../../../../assets/icons/Hamburger.svg';
import { notificationAction } from '../../../../Redux/action/interactions';

const Hamburger = () => {
  const [openDrawer , setOpenDrawer] = useState(false);

  const dispatch = useDispatch()
  
  const toggleFunc = () =>{
    setOpenDrawer(!openDrawer);
    dispatch(notificationAction(false))
  }

  return (
    <div className={classes.Hamburger}>
      <img src={HamburgerIcon} className={classes.HamburgerIcon} alt="hamburger" onClick={toggleFunc} />
      <DrawerMenu open={openDrawer} toggleFunc={toggleFunc}/>
    </div>
  );
}

export default memo(Hamburger)